import { Component, EventEmitter, Input, OnInit, Output, HostBinding, ElementRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-widget-numberbox',
    templateUrl: './widget-numberbox.component.html',
    styleUrls: ['./widget-numberbox.component.scss'],
    standalone: false
})
export class WidgetNumberboxComponent implements OnInit {
  @ViewChild('inputEl') inputEl: ElementRef<HTMLDivElement>;
  @Input() model: number;
  @Input() placeholder: string = "";
  @Output() modelChange = new EventEmitter<string>();
  @Input() title: string = "";
  @Input() textboxWidth: string = '200px';
  @Input() disabled: boolean = false;
  @Input() notifier: Subject<any>;
  @Input() isWidth: boolean;
  @Output() onEdit = new EventEmitter<any>();
  isFocus: boolean;
  public type: "number";

  constructor() { }
  ngOnInit(): void {
    this.notifier?.subscribe(value => {
      setTimeout(() => {
        this.inputEl.nativeElement.focus();
      }, 0)
    });
  }

  onEnter() {
    this.isFocus = false;
    this.onEdit.emit();
  }

  onBlur(event) {
    this.isFocus = false;
    if (this.isWidth && Number(event.currentTarget.value) > 3000) {
        this.model = 3000;
    }

    if (this.isWidth && Number(event.currentTarget.value) < 1900) {
        this.model = 1900;
    }

    if (!this.isWidth && Number(event.currentTarget.value) > 1800) {
        this.model = 1800;
    }

    if (!this.isWidth && Number(event.currentTarget.value) < 1000) {
        this.model = 1000;
    }

    this.onEdit.emit();
  }

  onKeyDown(event) {
    return event.keyCode !== 69;
  }
}
